const englishTranslations = {
  sidenav: {
    PROFILE: {
      detail: "Profile",
    },
    SETTING: {
      detail: "Setting",
    },
    FRIEND: {
      detail: "Refer to a friend",
      message1: "Invite Your friends to IC4",
      message2: "Send invite",
      message3: "Invite Your friends",
      message4: "Download IC4 App",
    },
    ABOUT: {
      detail: "About us",
    },
    PRIVACY: {
      detail: "Privacy and Security",
    },
    SIGNOUT: {
      detail: "Sign out",
      loading: "Logging out…",
    },
    LANGUAGE: {
      detail: "Change Language",
      "sub-detail": "English",
      message: "Your Language has been changed successfully.",
    },
    PASSWORD: {
      detail: "Change Password",
      message: "Create New Password",
      message1: "Create Password",
      message2: "Password",
      message3: "Password must be at least 8 characters.",
      message4: "Confirm Password",
      message5: "Both inputs do not match",
      message6: "Your Password has been changed successfully.",
      message7: "Both inputs match",
    },
    MOBILE: {
      detail: "Change Mobile Number",
      question: "New Mobile Number",
      inputLbl: "Mobile Number",
      otp: "Send OTP",
      sentotp: "OTP sent on",
      clearotp: "Clear OTP",
    },
    VERIFY_MOBILE: {
      message: "Your Phone number has been changed successfully.",
    },
    EMAIL: {
      detail: "Change Email",
      message: "Your Email ID has been changed successfully.",
    },
    ADDRESS: {
      detail: "Change Pin Code",
      message1: "If this is not your locality, please check your input",
      message2: "Your Pin Code has been changed successfully.",
      message3: "Yes, My pin code is correct",
    },
    HEALTH: {
      detail: "Your Health Information Updated successfully.",
    },
    "MY-PROFILE": {
      topHeading: "My Profile",
      patientid: "Patient ID",
      gender: "Gender",
      dob: "Age",
      mobile: "Mobile no.",
      email: "Email",
      pin: "Pin Code",
      location: "Location",
      send: "Send",
      login: "Back To Login",
      clinicId: "Clinic",
    },
  },
};

const marathiTranslations = {
  sidenav: {
    PROFILE: {
      detail: "प्रोफाइल",
    },
    SETTING: {
      detail: "सेटिंग्ज",
    },
    FRIEND: {
      detail: "मित्राला शिफारस करा",
      message1: "तुमच्या मित्रांना IC4 वर आमंत्रित करा",
      message2: "आमंत्रण पाठवा",
      message3: "तुमच्या मित्रांना आमंत्रित करा",
      message4: "IC4 अँप डाउनलोड करा",
    },
    ABOUT: {
      detail: "आमच्याबद्दल",
    },
    PRIVACY: {
      detail: "गोपनीयता आणि सुरक्षितता",
    },
    SIGNOUT: {
      detail: "साइन आउट करा",
      loading: "Logging out…",
    },
    LANGUAGE: {
      detail: "भाषा बदला",
      "sub-detail": "मराठी",
      message: "तुमची भाषा यशस्वीपणे बदलली गेली आहे.",
    },
    PASSWORD: {
      detail: "पासवर्ड बदला",
      message: "नवीन पासवर्ड तयार करा",
      message1: "पासवर्ड तयार करा",
      message2: "पासवर्ड",
      message3: "पासवर्ड मध्ये किमान 8 वर्ण असणे आवश्यक आहे..",
      message4: "पासवर्डची पुष्टी करा",
      message5: "दोन्ही इनपुट जुळत नाहीत",
      message6: "तुमचा पासवर्ड यशस्वीपणे बदलला गेला आहे",
      message7: "दोन्ही जुळले.",
    },
    MOBILE: {
      detail: "मोबाईल नंबर बदला",
      question: "नवीन मोबाईल नंबर",
      inputLbl: "मोबाईल नंबर",
      otp: "OTP पाठवा",
      sentotp: "OTP पाठवला आहे",
      clearotp: "OTP मिटवा",
    },
    VERIFY_MOBILE: {
      message: "तुमचा फोन नंबर यशस्वीपणे बदलला गेला आहे",
    },
    EMAIL: {
      detail: "ईमेल आयडी बदला",
      message: "तुमचा ईमेल आयडी यशस्वीपणे बदलली  गेली आहे",
    },
    ADDRESS: {
      detail: "पिनकोड बदला",
      message1: "जर हा तुमचा परिसर नसेल, तर कृपया तुमचा इनपुट तपासा.",
      message2: "तुमचा पिनकोड यशस्वीपणे बदलला गेला आहे",
      message3: "होय, माझा पिन कोड बरोबर आहे",
    },
    HEALTH: {
      detail: "तुमची आरोग्य माहिती यशस्वीपणे अपडेट झाली",
    },
    "MY-PROFILE": {
      topHeading: "माझे प्रोफाइल",
      patientid: "पेशंट आय डी",
      gender: "लिंग",
      dob: "वय",
      mobile: "मोबाईल क्र.",
      email: "ईमेल",
      pin: "पिन कोड",
      location: "स्थान",
      send: "पाठवा",
      login: "लॉगिन करण्यासाठी परत",
      clinicId: "क्लिनिक",
    },
  },
};

const hindiTranslations = {
  sidenav: {
    PROFILE: {
      detail: "प्रोफाइल",
    },
    SETTING: {
      detail: "सेटिंग्ज",
    },
    FRIEND: {
      detail: "एक दोस्त को सिफारिश करें",
      message1: "अपने दोस्तों को IC4 में आमंत्रित करें",
      message2: "आमंत्रण भेजो",
      message3: "अपने दोस्तों को आमंत्रित करें",
      message4: "IC4 ऐप डाउनलोड करें",
    },
    ABOUT: {
      detail: "हमारे बारे में",
    },
    PRIVACY: {
      detail: "गोपनीयता और सुरक्षा",
    },
    SIGNOUT: {
      detail: "साइन आउट",
      loading: "Logging out…",
    },
    LANGUAGE: {
      detail: "भाषा बदलो",
      "sub-detail": "हिन्दी",
      message: "आपकी भाषा सफलतापूर्वक बदल दी गई हैं।",
    },
    PASSWORD: {
      detail: "पासवर्ड बदलें",
      message: "नया पासवर्ड बनाएं",
      message1: "पासवर्ड बनाएं",
      message2: "पासवर्ड",
      message3: "पासवर्ड कम से कम 8 वर्णों का होना चाहिए।",
      message4: "पासवर्ड की जाँच कीजिये",
      message5: "दोनों इनपुट मेल नहीं खाते",
      message6: "आपका पासवर्ड सफलतापूर्वक बदल दिया गया हैं|",
      message7: "दोनों इनपुट समान हैं",
    },
    MOBILE: {
      detail: "मोबाइल नंबर बदलें",
      question: "नया मोबाइल नंबर",
      inputLbl: "मोबाइल नंबर",
      otp: "OTP भेजें",
      sentotp: "OTP भेजा गया",
      clearotp: "OTP मिटा दों ",
    },
    VERIFY_MOBILE: {
      message: "आपका फ़ोन नंबर सफलतापूर्वक बदल दिया गया हैं",
    },
    EMAIL: {
      detail: "ईमेल आईडी बदलें",
      message: "आपकी ईमेल आईडी सफलतापूर्वक बदल दी गई हैं",
    },
    ADDRESS: {
      detail: "पिनकोड बदलें",
      message1: "यदि यह आपका इलाका नहीं है, तो कृपया अपना इनपुट जांचें।",
      message2: "आपका पिनकोड सफलतापूर्वक बदल दिया गया हैं",
      message3: "हाँ, मेरा पिन कोड सही हैं",
    },
    HEALTH: {
      detail: "आपकी स्वास्थ्य जानकारी सफलतापूर्वक अपडेट की गई हैं",
    },
    "MY-PROFILE": {
      topHeading: "मेरी प्रोफाइल",
      patientid: "पेशंट आई डी",
      gender: "लिंग",
      dob: "आयु",
      mobile: "मोबाइल न.",
      email: "ईमेल",
      pin: "पिन कोड",
      location: "स्थान",
      send: "भेजना",
      login: "लॉगिन पर वापस जाएं",
      clinicId: "क्लिनिक",
    },
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
